
export interface tabletansuat {
    id?: string;
    isEditBaoCao?: boolean;
    idbaocao: string; // required, default ''
    title: string; // required, default ''
    baocaochoky: string; // required, default ''
    filedinhkem: string; // required, default ''
    current: boolean; // required, default false
    currentamong: boolean; // required, default false
    batdau: string | Date; // ISO string or Date object, default new Date()
    ketthuc: string | Date; // default new Date()
    tungay: string; // required, default ''
    baseline: number; // required, default 0
    accept: number; // required, default 0
    chiTieu: number; // required, default 0
    max: number; // required, default 0
    thucTe: number | null; // required, default 0
    /** Nhập tay Ver 1 (mode báo cáo riêng). */
    thucTeNhapV1?: number | null;
    /** Nhập tay Ver 2 (mode báo cáo riêng). */
    thucTeNhapV2?: number | null;
    /** ID bản ghi tiến độ Ver 1. */
    idbaocaoV1?: string | null;
    /** ID bản ghi tiến độ Ver 2. */
    idbaocaoV2?: string | null;
    /** Kết quả theo tỉ trọng Ver 1 (readonly trên UI). */
    thucTeV1?: number | null;
    /** Kết quả theo tỉ trọng Ver 2 (readonly trên UI). */
    thucTeV2?: number | null;
    /** Tử số / mẫu số (KPI tỉ lệ HinhThuc=4) */
    tuSo?: number | null;
    mauSo?: number | null;
    tuSo_Temp?: number | null;
    mauSo_Temp?: number | null;
    tuSoChiTieu?: number | null;
    mauSoChiTieu?: number | null;
    thucTeHienThi: string; // required, default ''
    icon: string; // required, default ''
    color: string; // required, default ''
    tinhTrang: string; // required, default ''
    danhGia: string; // required, default ''
    soNgayConLai: number; // required, default 0
    dabaocao: string; // required, default ''
    choduyetbaocao: string; // required, default ''
    thucTeBieuDo: number; // required, default 0
    trangThai?: boolean; // optional, default false
    chiTieuTienDo: number; // required, default 0
    hieuSuatThucTe: number; // required, default 0
    hieuSuatThucTeTooltip: number; // required, default 0
    hoanThanhCaNam: number; // required, default 0
    phanTramTiTrongTooltip: number; // required, default 0
    phanTramTiTrong: number; // required, default 0
    tiTrongDatDuoc: number; // required, default 0
    thucTe_Temp: number; // required, default 0
    ngay_Temp?: string | Date; // optional, default new Date()
    ngay?: string | Date; // optional, default new Date()
    guiDuyet: boolean; // required, default false
    sendRoleApproveID: string | ""; // required, default ''
    tinhTrangDuyet: number; // required, default 0
    capDoDuyet: number; // required, default 0
    nhanVienDuyet: string | ""; // required, default ''
    ghiChuDuyet: string; // required, default ''
    soBaoCao: number; // required, default 0
    soDaBaoCao: number; // required, default 0
    mtbpKPIID?: string; // optional, default ''
    trangthaidabaocao: number; // required, default 0
    tiTrongDatDuocTooltip: number; // required, default 0
    isLogFile: boolean; // required, default false
    loaiKPI: boolean; // required, default false
    /** Kỳ được chọn là KPI thưởng (tính thưởng độc lập, Bước 6). */
    isKPIBonus?: boolean;
    /** Tỉ trọng thưởng khai báo riêng cho kỳ (đơn vị %). */
    tiTrongKPIBonus?: number;
    isVisible?: boolean; // optional, for UI filtering
}

// Default values to use in case backend is missing required fields
export const defaultTabletansuat: tabletansuat = {
    idbaocao: '',
    title: '',
    baocaochoky: '',
    filedinhkem: '',
    current: false,
    currentamong: false,
    batdau: new Date(),
    ketthuc: new Date(),
    tungay: '',
    baseline: 0,
    accept: 0,
    chiTieu: 0,
    max: 0,
    thucTe: 0,
    tuSo: null,
    mauSo: null,
    tuSo_Temp: null,
    mauSo_Temp: null,
    tuSoChiTieu: null,
    mauSoChiTieu: null,
    thucTeHienThi: '',
    icon: '',
    color: '',
    tinhTrang: '',
    danhGia: '',
    soNgayConLai: 0,
    dabaocao: '',
    choduyetbaocao: '',
    thucTeBieuDo: 0,
    trangThai: false,
    chiTieuTienDo: 0,
    hieuSuatThucTe: 0,
    hieuSuatThucTeTooltip: 0,
    hoanThanhCaNam: 0,
    phanTramTiTrongTooltip: 0,
    phanTramTiTrong: 0,
    tiTrongDatDuoc: 0,
    thucTe_Temp: 0,
    ngay_Temp: new Date(),
    ngay: new Date(),
    guiDuyet: false,
    sendRoleApproveID: '',
    tinhTrangDuyet: 0,
    capDoDuyet: 0,
    nhanVienDuyet: '',
    ghiChuDuyet: '',
    soBaoCao: 0,
    soDaBaoCao: 0,
    mtbpKPIID: '',
    trangthaidabaocao: 0,
    tiTrongDatDuocTooltip: 0,
    isLogFile: false,
    loaiKPI: false,
    isKPIBonus: false,
    tiTrongKPIBonus: 0,
    isVisible: true
};